
import Vue from 'vue'

import Command from "@/utils/command";
Vue.use(Command);

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css
import '@/assets/iconfont/iconfont.css' //iconfont图标库
import "@/utils/filters"

import "@/utils/time"
import App from './App'
import store from './store'
import router from '@/utils/router'

import 'vue-ztree-2.0/dist/vue-ztree-2.0.css'

import 'font-awesome/css/font-awesome.min.css'

import "@/utils/directives"

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)


// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.goodsionTip = false


// 提取公共的 getQueryVariable 方法
function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return undefined;
}

// 外部链接不附加sid，与菜单URL处理保持一致，避免sid拼入hash片段导致锚点失效
function isExternalUrl(url) {
  try {
    return new URL(url, window.location.href).origin !== window.location.origin
  } catch (e) {
    return false
  }
}

// 保存原始的 window.open 方法
const originalWindowOpen = window.open;

// 重写 window.open 方法
window.open = function (url, target, features) {
  // 添加sid
  if (url && typeof url === 'string' && !isExternalUrl(url) && url.indexOf('?sid=') == -1 && url.indexOf('&sid=') == -1) {
    let sid = getQueryVariable("sid");
    if (sid) {
      url += (url.indexOf('?') == -1 ? "?" : "&")
      url += `sid=${sid}`
    }
  }
  // 调用原始的 window.open 方法
  return originalWindowOpen.call(window, url, target, features);
};
document.addEventListener('click', function (event) {
  // 判断点击的是否是 <a> 标签
  const link = event.target.closest('a');
  if (!link) return;
  let url = link.href;
  if(!url) return;
  //添加sid
  if (!isExternalUrl(url) && url.indexOf('?sid=') == -1 && url.indexOf('&sid=') == -1) {
    //把当前sid添加进url
    let sid = getQueryVariable("sid");
    if (sid) {
      url += (url.indexOf('?') == -1 ? "?" : "&")
      url += `sid=${sid}`
    }
  }
  if (link.target === '_blank') {
    event.preventDefault();
    window.open(url, '_blank');
  }
  
}, true);

// 全局导航方法，自动添加 sid
window.navigateWithSid = function(url) {
  if (url && typeof url === 'string' && url.indexOf('?sid=') == -1 && url.indexOf('&sid=') == -1) {
    let sid = getQueryVariable("sid");
    if (sid) {
      url += (url.indexOf('?') == -1 ? "?" : "&") + `sid=${sid}`
    }
  }
  window.location.href = url;
};

let initialize = async function () {

  //如果已有identity，则先获取identit，menu，feature
  const identity = localStorage.getItem('identity');
  if (identity) {
    try {
      let raclStore = await store.dispatch('racl/get', true);
      updateFavicon(raclStore.identity.data);
    } catch (e) {
      console.log(e)
    }
  }
  global.gApp = new Vue({
    router,
    store,
    render: h => h(App)
  })

  global.merchApp = global.gApp;
  global.gApp.config = process.env;
  global.gApp.$mount("#app");
}

function updateFavicon(identity) {
  if (!identity) return;
  let iconUrl = `/default.ico`;
  if (identity.logo) {
    iconUrl = identity.logo;
  }

  let link = document.querySelector("link[rel~='icon']");

  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  // 防止浏览器缓存旧的 icon
  link.href = `${iconUrl}?v=${Date.now()}`;
}

initialize()

